module.exports = "import React from 'react';\nimport Slider from 'material-ui/Slider';\n\nconst SliderExampleDisabled = () => (\n  <div>\n    <Slider disabled={true} />\n    <Slider disabled={true} value={0.5} />\n    <Slider disabled={true} value={1} />\n  </div>\n);\n\nexport default SliderExampleDisabled;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/Slider/ExampleDisabled.js
 ** module id = 1048
 ** module chunks = 0
 **/